<template>
    <div>
        <div ref="trigger">
        <slot>
            <ui-button 
                :disabled="disabled"
                icon="access_time" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Due Date</ui-button>
        </slot>
        </div>
        <ui-popover ref="assignPopover" :trigger="$refs.trigger" v-show="!disabled" :contain-focus="true" class="due-at-selector">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Due Date</div>
            <div style="padding: 1rem; width: 15rem;">
                <!--<ui-select 
                    has-search
                    placeholder="Select team member" 
                    v-model="selected" 
                    :options="users" 
                    :keys="{ label: 'name', value: 'id' }"
                ></ui-select>!-->
                <ui-datepicker 
                    v-model="selected" 
                    @close="dateSelected" 
                    placeholder="Select due date"
                    :custom-formatter="dateFormatter"
                    @input="dateChanged"
                    append-dropdown-to-body
                    :start-of-week="1"
                ></ui-datepicker>
                <vue-timepicker
                    v-model="timeProxy"
                    close-on-complete
                    placeholder="Time"
                    :minute-interval="5"
                    ref="timePicker"
                ></vue-timepicker>
                <ui-button :loading="isLoading" @click="save">Save</ui-button>
                <ui-button v-show="selected" :disabled="isLoading" @click="destroy" color="red">Remove</ui-button>
            </div>
        </ui-popover>
    </div>
</template>

<style lang="scss">
    .due-at-selector {
        .time-picker {
            .display-time {
                border-top: none;
                border-left: none;
                border-right: none;
                padding-left: 0;
                padding-right: 0;
                margin-bottom: 1rem;
            }

            .clear-btn { bottom: 1rem; }
        }
    }
</style>

<script>
    import Moment from 'moment'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'

    export default {
        components: {
            VueTimepicker,
        },
        props: {
            isLoading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            dueAt: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            }
        },
        mounted() {
            if (this.dueAt) {
                let dueAt = this.dueAt;

                if (typeof dueAt === 'string') {
                   dueAt = Moment(dueAt, ['YYYY-MM-DDTHH:mm:ssZ']).toDate() //2018-11-15T00:00:00+00:00
                }

                this.selected = dueAt
            }
        },
        watch: {
            dueAt: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        if (newVal && !(newVal instanceof Object)) {
                            newVal = (new Moment(newVal)).toDate();
                        }

                        this.selected = newVal;
                    }
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: new Date,
            }
        },
        computed: {
            timeProxy: {
                get() {
                    if (!this.selected || this.selected.getHours() === 0 && this.selected.getMinutes() === 0) {
                        this.$nextTick(() => {
                            this.$refs.timePicker.clearTime();
                        })
                        return {
                            HH: '00',
                            mm: '00',
                            ss: '00',
                        };
                    }

                    return {
                        HH: this.formatTimeString(this.selected.getHours()),
                        mm: this.formatTimeString(this.selected.getMinutes()),
                        ss: this.formatTimeString(0)
                    }
                },
                set(value) {
                    if (this.selected) {
                        this.selected.setHours(value.HH)
                        this.selected.setMinutes(value.mm)
                    }
                }
            }
        },
        methods: {
            formatTimeString(time) {
                let formatted = time.toString()
                if (time < 10) {
                    return '0'.concat(time)
                }

                return time.toString()
            },
            dateChanged() {
                if (this.selected) {
                this.selected.setHours(0)
                this.selected.setMinutes(0)
                }
            },
            dateFormatter(date) {
                return (new Moment(date)).format('DD/MM/YYYY');
            },
            dateSelected() {
                this.$nextTick(() => {
                    this.$refs.assignPopover.open();
                })
            },
            save() {
                //this.selected.setHours(0)
                //this.selected.setMinutes(0)
                //this.selected.setSeconds(0)
                this.$emit('save', this.selected);
            },
            destroy() {
                this.selected = null;
                this.$emit('save', null);
            },
            reset() {
                this.$refs['assignPopover'].close();
            },
            show() {
                this.$refs.assignPopover.open()
            }
        }
    }
</script>